import {Menu, MenuItem, MenuText} from '../../../menu/menu';
import {handleLogout} from '../../../../../helpers/auth-helper';
import {useSessionUser} from '../../../../../hooks/use-session';
import {useTranslation} from '../../../../../hooks/use-translation';

/** The user's avatar, with a menu that has their name and logs out. */
export const TopNavUser = (): React.JSX.Element | null => {
    const t = useTranslation();
    const user = useSessionUser();

    if (null === user) {
        return null;
    }

    return (
        <Menu
            className="button button-small button-quiet top-bar-user"
            aria-label={t('topNav.userMenu', {name: user.name})}
            // the button names it, the picture is decoration
            label={<img src={user.image} alt="" />}
        >
            <MenuText>{user.name}</MenuText>
            <MenuItem onSelect={handleLogout}>{t('topNav.logout')}</MenuItem>
        </Menu>
    );
};
